export const TENANT_DOMAINS_RESET_STATE = 'TENANT_DOMAINS_RESET_STATE';
export const TENANT_DOMAINS_CURRENT_ITEM = 'TENANT_DOMAINS_CURRENT_ITEM';
 
export const TENANT_DOMAINS_REQUEST_LOADING = 'TENANT_DOMAINS_REQUEST_LOADING';
export const TENANT_DOMAINS_REQUEST_SUCCESS = 'TENANT_DOMAINS_REQUEST_SUCCESS';
export const TENANT_DOMAINS_REQUEST_FAILED = 'TENANT_DOMAINS_REQUEST_FAILED';
 
export const TENANT_DOMAINS_CURRENT_ACTION = 'TENANT_DOMAINS_CURRENT_ACTION';
export const TENANT_DOMAINS_RESET_ACTION = 'TENANT_DOMAINS_RESET_ACTION';